import React from 'react'
import {
  Breadcrumbs,
  Grid,
  Button,
  Input,
  Tooltip,
} from '@design-systems/canvas-ui'
import Icon, {
  ChevronLeftIcon,
  TimeHistoryIcon,
  ChatIcon,
} from '@design-systems/react-icons'
import {
  PARAM_SUPPLIER_ID,
  PARAM_LOCATION_ID,
  PARAM_MANUFACTURING_TYPE_ID,
  ROUTE_VETTING_SUMMARY_LOCATION,
} from '../../../../common/commonConstants'
import { rfiCapabilityTypeMapper } from '../../../../globalComponents/RfiConstants/rfiCapabilityTypeMapper'
import Rfi3Banner from './Rfi3Banner'

const Rfi3Header = ({
  rfi3Data,
  rfi3Template,
  navigate,
  isAuditTrailOpen,
  isCommentsOpen,
  setIsAuditTrailOpen,
  setIsCommentsOpen,
}) => {
  if (!rfi3Data) return null

  return (
    <Grid.Container
      spacing="normal"
      justify="space-between"
      className="hc8-mt-4x hc8-ph-4x"
    >
      <Breadcrumbs>
        <Breadcrumbs.Item
          href={`/lcm/internal/rfi1?${PARAM_SUPPLIER_ID}=${rfi3Data?.supplier_id}&${PARAM_MANUFACTURING_TYPE_ID}=${rfi3Data?.manufacturing_type_id}`}
        >
          Supplier
        </Breadcrumbs.Item>
        <Breadcrumbs.Item
          href={`/lcm/internal/rfi2?${PARAM_LOCATION_ID}=${rfi3Data?.location_id}&${PARAM_SUPPLIER_ID}=${rfi3Data?.supplier_id}&${PARAM_MANUFACTURING_TYPE_ID}=${rfi3Data?.manufacturing_type_id}`}
        >
          Location Details
        </Breadcrumbs.Item>
        <Breadcrumbs.Item>
          {rfiCapabilityTypeMapper[rfi3Data?.manufacturing_type?.toLowerCase()]}
        </Breadcrumbs.Item>
      </Breadcrumbs>

      <Grid.Container
        spacing="normal"
        justify="space-between"
        className="hc8-ph-4x hc8-mb-none"
      >
        <Grid.Item className="row-centre">
          <div className="align-centre-left">
            <Button
              onClick={() => navigate(ROUTE_VETTING_SUMMARY_LOCATION)}
              variant="ghost"
              isIconOnly
              aria-label="Go back"
            >
              <Icon svg={ChevronLeftIcon} className="hc8-clr-base" size="xl" />
            </Button>

            <Input.Label className="hc8-fs-150 hc8-clr-base font-weight-500 hc8-ma-none">
              {
                rfi3Data?.fixed_sections?.factory_contact_information
                  ?.location_name
              }
            </Input.Label>
          </div>
        </Grid.Item>

        <Grid.Item className="row-centre">
          <div
            className="align-centre-left hc8-mr-2x"
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: '8px',
              whiteSpace: 'nowrap',
            }}
          >
            <Tooltip
              content="View full history of changes to this RFI form"
              location="bottom"
            >
              <Button
                key="btn-header-audit-trail-rfi3"
                onClick={() => setIsAuditTrailOpen(true)}
                variant={isAuditTrailOpen ? 'primary' : 'ghost'}
                aria-label="Click to open Audit Trail drawer"
                style={{ border: '1px solid #4a73d9' }}
              >
                <Icon className="row-centre" svg={TimeHistoryIcon} />
                <span className="hc8-ml-1x">Audit Trail</span>
              </Button>
            </Tooltip>

            <Tooltip
              content="Add comments or @mention Target team members or Supplier"
              location="bottom"
            >
              <Button
                key="btn-header-chat-rfi3"
                onClick={() => setIsCommentsOpen(true)}
                variant={isCommentsOpen ? 'primary' : 'ghost'}
                aria-label="Click to open chat drawer"
                style={{ border: '1px solid #4a73d9' }}
              >
                <Icon className="row-centre" svg={ChatIcon} />
                <span className="hc8-ml-1x">Comments</span>
              </Button>
            </Tooltip>
          </div>
        </Grid.Item>
      </Grid.Container>

      <Rfi3Banner rfi3Data={rfi3Data} rfi3Template={rfi3Template} />
    </Grid.Container>
  )
}

export default React.memo(Rfi3Header)
